<div class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md">
    <div class="trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between">
        <div class="trezo-card-title">
            <h5 class="!mb-0">
                GitHub Style Area Chart
            </h5>
        </div>
    </div>
    <div class="trezo-card-content">
        <div id="github_style_area_chart"></div>
        <div class="flex items-center gap-[12px]">
            <img src="images/admin.png" class="rounded-full" width="50" alt="user-image">
            <div class="title">
                <span class="block text-black dark:text-white font-semibold">
                    Olivia John
                </span>
                <span class="block mt-[2px]">
                    Coder
                </span>
            </div>
        </div>
        <div id="github_style_area_chart2"></div>
    </div>
</div>